import React from "react";

export const ContextShipper = React.createContext<{ shipper: any; setShipper: any }>({
  shipper: null,
  setShipper: () => {},
});